import RadioButtonGroup from "Components/RadioButtonGroup/RadioButtonGroup";
import { Button } from "Components/ui/button";
import { useEffect, useState } from "react";
import "./CreateChallenge.scss";

import { useAuth } from "@clerk/clerk-react";
import { Checkbox } from "Components/ui/checkbox";
import { Separator } from "Components/ui/separator";
import { Skeleton } from "Components/ui/skeleton";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  createChallenge,
  getChallengeDetails,
  getChallengeTypes,
  getCurrencies,
  getPlatforms,
} from "../../Redux/ChallengeSetup/ChallengeSetupAction";
import DropDown from "Components/DropDown/DropDown";
import UseInnerWidth from "hooks/UseInnerWidth";
import mt5Icon from "../../Assets/Images/mt5icon.svg";
import tradelockerIcon from "../../Assets/Images/tradelockerIcon.svg";
import TradeLockerBlack from "../../Assets/Images/TradeLockerBlack.svg";
import { useTheme } from "hooks/ThemeContext";

function CreateChallenge({ fromLanding }) {
  const { theme } = useTheme();
  const {
    challengeTypes,
    challengeTypesLoading,
    currencies,
    currenciesLoading,
    platforms,
    platformsLoading,
    challengeInfo,
    challengeInfoLoading,
    createChallengeLoading,
  } = useSelector((state) => state.ChallengeSetupReducer);

  const [searchParams, setSearchParams] = useSearchParams();

  const dispatch = useDispatch();

  const { getToken } = useAuth();
  const { user } = useSelector((state) => state.ProfileReducer);

  const navigate = useNavigate();
  const [selectedChallenge, setSelectedChallenge] = useState();
  const [selectedCurrency, setSelectedCurrency] = useState();
  const [selectedPlatform, setSelectedPlatform] = useState();
  const [currenciesArray, setCurrenciesArray] = useState([]);
  const [platformsArray, setPlatformsArray] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState();
  const [selectedBalance, setSelectedBalance] = useState();
  const [accountBalance, setAccountBalance] = useState([]);
  const [accountType, setAccountType] = useState([]);
  const [acceptConditions, setAcceptConditions] = useState();

  const [totalAmount, setTotalAmount] = useState(0);

  const [cTypes, setCTypes] = useState([]);

  //get challenge types, currencies and platforms
  useEffect(() => {
    dispatch(getChallengeTypes());
    dispatch(getCurrencies());
    dispatch(getPlatforms());
  }, []);

  //if challenge types, set the challenge types in a new array
  useEffect(() => {
    if (challengeTypes?.length > 0) {
      setCTypes([]);

      challengeTypes.map((item) => {
        if (!searchParams.get("type") && item?.name == "Algorithmic Affair") {
          setSelectedChallenge(item?.id);
        } else if (
          searchParams.get("type") &&
          item?.name == searchParams.get("type")
        ) {
          setSelectedChallenge(item?.id);
        }
        setCTypes((prev) => [
          ...prev,
          {
            label: item.name,
            value: item.id,

            desc: item?.description,
          },
        ]);
      });
    } else {
      setCTypes([]);
    }
  }, [challengeTypes, searchParams]);

  //if currencies, set the currencies in a new array
  useEffect(() => {
    if (currencies?.length > 0) {
      setCurrenciesArray([]);

      setSelectedCurrency({
        value: currencies[0].id,
        label: currencies[0].symbol,
        img: currencies[0]?.image,
      });
      currencies.map((item) => {
        setCurrenciesArray((prev) => [
          ...prev,
          { label: item.symbol, value: item.id, img: item?.image },
        ]);
      });
    } else {
      setCurrenciesArray([]);
    }
  }, [currencies]);

  //if platforms, set the platforms in a new array
  useEffect(() => {
    if (platforms?.length > 0) {
      setPlatformsArray([]);

      if (!searchParams.get("platform")) {
        setSelectedPlatform(platforms[0].id);
      } else if (searchParams.get("platform")) {
        setSelectedPlatform(
          platforms.find((item) => item.name == searchParams.get("platform"))
            ?.id
        );
      }
      platforms.map((item) => {
        setPlatformsArray((prev) => [
          ...prev,
          { label: item.name, value: item.id, img: item?.image },
        ]);
      });
    } else {
      setPlatformsArray([]);
    }
  }, [platforms, searchParams]);

  //get challenge details if challenge type and currency is selected
  useEffect(() => {
    if (selectedChallenge && selectedCurrency) {
      setAccountBalance([]);
      setAccountType([]);
      dispatch(
        getChallengeDetails({
          challengeTypeId: selectedChallenge,
          currencyId: selectedCurrency.value,
        })
      );
    }
  }, [selectedChallenge, selectedCurrency]);

  //if challenge details, set the account balance and account type in a new array
  useEffect(() => {
    if (challengeInfo?.AccountBalances?.length > 0) {
      setAccountBalance([]);

      challengeInfo?.AccountBalances.map((item) => {
        if (!searchParams.get("balance") && item?.amount == 100000) {
          setSelectedBalance(item?.id);
        } else {
          if (
            searchParams.get("balance") &&
            item?.amount == searchParams.get("balance")
          ) {
            setSelectedBalance(item?.id);
          }
        }
        setAccountBalance((prev) => [
          ...prev,
          {
            label: item.amount?.toLocaleString() + " " + item?.Currency?.symbol,
            value: item.id,
            price: item?.ChallengeBalance?.[0]?.price,
          },
        ]);
      });
    } else {
      setAccountBalance([]);
    }
    if (challengeInfo?.AccountTypes?.length > 0) {
      setAccountType([]);
      challengeInfo?.AccountTypes.map((item) => {
        if (item?.name == "Optimal") {
          setSelectedAccount(item?.id);
        }
        setAccountType((prev) => [
          ...prev,
          { label: item.name, value: item.id, disabled: item?.disabled },
        ]);
      });
    } else {
      setAccountType([]);
    }
  }, [challengeInfo, searchParams]);

  //create challenge
  const handleCreateChallenge = () => {
    if (fromLanding) {
      localStorage.setItem("challengeTypeId", selectedChallenge);
      localStorage.setItem("currencyId", selectedCurrency.value);
      localStorage.setItem("platformId", selectedPlatform);
      localStorage.setItem("balanceId", selectedBalance);
      localStorage.setItem("accountTypeId", selectedAccount);
      localStorage.setItem("isFree", true);
      navigate("/?tab=Register");
    } else {
      dispatch(
        createChallenge(
          getToken,
          {
            challengeTypeId: selectedChallenge,
            currencyId: selectedCurrency.value,
            platformId: selectedPlatform,
            balanceId: selectedBalance,
            accountTypeId: selectedAccount,
            isFree: true,
          },
          navigate
        )
      );
    }
  };

  useEffect(() => {
    if (
      selectedBalance &&
      accountBalance.find((item) => item.value === selectedBalance)?.price
    ) {
      setTotalAmount(
        accountBalance.find((item) => item.value === selectedBalance)?.price
      );
    }
  }, [accountBalance, selectedBalance]);
  const width = UseInnerWidth();

  return (
    <div
      className={
        fromLanding
          ? "pb-10 w-full challenge_setUp m-auto max-w-[1024px] my-10"
          : "pb-10 w-full challenge_setUp"
      }
    >
      {" "}
      <div className="bg-background sm:px-8 sm:py-10 border-2 border-border-darkNew rounded-xl px-4 py-6 ">
        <div className="flex flex-col gap-5 ">
          <div className="flex  gap-4 sm:flex-row flex-col w-fit">
            {currenciesLoading ? (
              <Skeleton className="bg-background-secondary px-4  py-2 rounded-xl w-44" />
            ) : (
              <DropDown
                withImages
                withLabel
                data={currenciesArray}
                placeholder={"Select Currency"}
                title={width > 400 ? "Currency" : ""}
                selected={selectedCurrency}
                setSelected={setSelectedCurrency}
              />
            )}
          </div>
        </div>
        <Separator className="my-10 bg-border-darkNew h-[0.15rem]" />
        <div>
          <div className="text-2xl mb-6 font-N_Bol">Challenge Platform</div>
          {challengeTypesLoading ? (
            <div className="grid grid-cols-4 gap-4 w-ful">
              {Array(2)
                ?.fill(0)
                ?.map((item, index) => (
                  <Skeleton className="border-2 border-border-darkNew bg-background-secondary cursor-pointer flex-1 p-3 rounded-xl h-12 " />
                ))}
            </div>
          ) : (
            <RadioButtonGroup
              uniqueName={"platform"}
              grid={4}
              data={platformsArray?.map((item) => ({
                label: (
                  <div className="flex  gap-2 items-center text-white">
                    <img
                      src={
                        item?.label === "Platform 5"
                          ? mt5Icon
                          : item?.label === "Trade Locker"
                          ? theme === "light"
                            ? TradeLockerBlack
                            : tradelockerIcon
                          : mt5Icon
                      }
                      alt="USD"
                      className="w-3"
                    />
                    <div>{item?.label}</div>
                  </div>
                ),
                value: item.value,
                disabled: item?.label === "Trade Locker" && true

              }))}
              checked={selectedPlatform}
              setChecked={setSelectedPlatform}
            />
          )}
        </div>
        <Separator className="my-10 bg-border-darkNew h-[0.15rem]" />

        <div className="text-2xl mb-6 font-N_Bold">
          Choose your challenge type
        </div>
        {challengeTypesLoading ? (
          <div className="grid grid-cols-4 gap-4 w-ful">
            {Array(4)
              ?.fill(0)
              ?.map((item, index) => (
                <Skeleton className="border-2 border-border-darkNew cursor-pointer flex-1 p-3 rounded-xl h-12 bg-background-secondary " />
              ))}
          </div>
        ) : (
          <RadioButtonGroup
            uniqueName={"challengeType"}
            data={cTypes}
            checked={selectedChallenge}
            setChecked={setSelectedChallenge}
          />
        )}
        <div className="text-white-opacity bg-background-secondary p-4 my-5 rounded-lg text-xs">
          {cTypes.find((item) => item.value === selectedChallenge)?.desc}
        </div>
        <Separator className="my-10 bg-border-darkNew h-[0.15rem]" />
        <div className="text-2xl mb-6">Account Balance</div>
        {challengeInfoLoading ? (
          <div className="grid grid-cols-4 gap-4 w-ful">
            {Array(6)
              ?.fill(0)
              ?.map((item, index) => (
                <Skeleton className="border-2 border-border-darkNew cursor-pointer flex-1 p-3 rounded-xl h-12 bg-background-secondary " />
              ))}
          </div>
        ) : (
          <RadioButtonGroup
            uniqueName={"accountBalance"}
            data={accountBalance}
            checked={selectedBalance}
            setChecked={setSelectedBalance}
          />
        )}
        <Separator className="my-10 bg-border-darkNew h-[0.15rem]" />

        {/* <div className="text-2xl mb-6">Account Type</div>
          {challengeInfoLoading ? (
            <div className="grid grid-cols-4 gap-4 w-ful">
              {Array(4)
                ?.fill(0)
                ?.map((item, index) => (
                  <Skeleton className=" border-2 border-border-darkNew cursor-pointer flex-1 p-3 rounded-xl h-12 bg-background-opacity " />
                ))}
            </div>
          ) : (
            <RadioButtonGroup
              uniqueName={"accountType"}
              data={accountType}
              checked={selectedAccount}
              setChecked={setSelectedAccount}
            />
          )}

          <Separator className="my-10 bg-border-darkNew h-[0.15rem]" /> */}

        <div className="flex w-full sm:items-center justify-between pb-10 sm:flex-row flex-col gap-4">
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-4">
              <Checkbox
                id="acceptConditions_1"
                checked={acceptConditions?.first}
                onClick={(e) =>
                  setAcceptConditions({
                    ...acceptConditions,
                    first: !acceptConditions?.first,
                  })
                }
              />
              <label
                className="text-sm text-white cursor-pointer font-N_Medium"
                htmlFor="acceptConditions_1"
              >
                I declare that I have read and agree with{" "}
                <span
                  onClick={(e) => {
                    e.stopPropagation();

                    window.open("/termsNConditions", "_blank");
                  }}
                  className="text-sm underline cursor-pointer font-N_Medium"
                >
                  Terms & Conditions{" "}
                </span>
              </label>
            </div>
            <div className="flex items-center gap-4  ">
              <Checkbox
                id="acceptConditions_2"
                checked={acceptConditions?.second}
                onClick={(e) =>
                  setAcceptConditions({
                    ...acceptConditions,
                    second: !acceptConditions?.second,
                  })
                }
              />
              <label
                className="text-sm text-white cursor-pointer font-N_Medium"
                htmlFor="acceptConditions_2"
              >
                I declare that I have read and agree with{" "}
                <span
                  onClick={(e) => {
                    e.stopPropagation();

                    window.open("/privacyPolicy", "_blank");
                  }}
                  className="text-sm underline cursor-pointer font-N_Medium"
                >
                  Cancellation & Refund Policy{" "}
                </span>
              </label>
            </div>
          </div>
        </div>

        <Button
          className="w-full"
          disabled={
            !(
              selectedChallenge &&
              selectedCurrency &&
              selectedPlatform &&
              selectedAccount &&
              selectedBalance &&
              acceptConditions?.first &&
              acceptConditions?.second
            ) || createChallengeLoading
          }
          onClick={() => handleCreateChallenge()}
        >
          {createChallengeLoading ? "Processing..." : "Create Challenge"}
        </Button>
        <p className="text-white-opacity text-xs mt-4">
          All information provided on this site is intended solely for
          educational purposes related to trading on financial markets and does
          not serve in any way as a specific investment recommendation, business
          recommendation, investment opportunity analysis or similar general
          recommendation regarding the trading of investment instruments. The
          information on this site is not directed at residents in any country
          or jurisdiction where such distribution or use would be contrary to
          local laws or regulations. Only Funds does not act as a broker and
          does not accept any deposits. Due to the volatile nature of live
          markets, these challenges may be difficult to pass, even for
          experienced traders. As such, they are not recommended for individuals
          with little or no prior trading experience. The offered technical
          solution and data feed is powered by liquidity providers.
          <br /> Copyright © 2025 Only Funds. All rights reserved.
        </p>
      </div>
    </div>
  );
}

export default CreateChallenge;
